import Icon from 'shopper/components/Icon';

import { toOfferLink } from 'lib/links';
import trackEvent from 'lib/posthog/trackEvent';
import { formatOfferShareText, shareTo } from 'lib/share';

import APP from 'constants/app';
import SOCIAL_MEDIA from 'constants/socialMedia';

const WhatsAppShareIconButton = ({
  offerId,
  offerSlug,
  offerTitle,
  offerPrice,
  offerPriceType,
}) => {
  const onClick = (e) => {
    e.preventDefault();
    e.stopPropagation();

    shareTo({
      offerTitle,
      offerPrice,
      offerPriceType,
      socialMedia: SOCIAL_MEDIA.WHATSAPP.TITLE,
      url: `${APP.URL}${toOfferLink(offerSlug)}`,
      formatShareTextFn: formatOfferShareText,
    });

    trackEvent(
      'click home offer whatsapp share',
      { offer_id: offerId },
      { destination: 'posthog' }
    );
  };

  return (
    <button
      aria-label="Compartilhar no WhatsApp"
      className="flex h-8 w-8 cursor-pointer items-center justify-center rounded-full border border-solid border-neutral-high-300 bg-neutral-high-100 transition-colors hover:bg-neutral-high-200 dark:border-0 dark:bg-neutral-low-500 dark:hover:bg-neutral-low-400"
      type="button"
      onClick={onClick}
    >
      <Icon className="text-[16px] text-success-300" name="whatsapp" />
    </button>
  );
};

export default WhatsAppShareIconButton;
